

<div class="profile-container">
    <div class="">
        <div class="profile-content">
            <div class="personal-details">
              <div class="header-block">
                <div class="header-title">
                  <app-breadcrumb></app-breadcrumb>
                </div>
                <div class="add-block">
                  <div class="search">
                    <form autocomplete="off" >
                        <input type="text" placeholder="search user" [(ngModel)]="search">
                    </form>
                    <i class="bi bi-search" ></i>
                  </div>
                </div>
              </div>
                <div class="row">
                  <!-- <div class="col-md-5 col-lg-5" style="margin-bottom: 10px;">
                    <label class="user">User Latest Location Tracking</label>
                  </div> -->
                  <div class="col-md-9 col-lg-9">
                    <div class="map-container">
                      <div class="map-frame">
                        <div id="map">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3 col-lg-3" style="padding-left: 0;">
                    <div class="options">
                        <button *ngIf="!isSelectAll" (click)="selectAllToggle('select all')">Select All</button>
                        <button *ngIf="isSelectAll" (click)="selectAllToggle('deselect all')">Deselect All</button>
                        <button (click)="getEmployeeLocationTrackingByIdAndLastDatetime()">Show Location(s)</button>
                    </div>
                    <div class="usersList">
                      <div class="location" *ngFor="let list of usersList | filter:search">
                        <p>
                          <input type="checkbox" [(ngModel)]="list.isChecked" (click)="userChecked($event,list.userId)"> <span (click)="setCenter(list.userId)">{{list.userName}} ({{list.userId}})</span>
                       </p>
                       <div>
                        <span *ngIf="list.trackingData && list.trackingData.length != 0">Last Date : {{list.trackingData.currentDateTime | date : 'medium'}}</span>
                       </div>
                      </div>
                        
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</div>